import React from 'react';
import { IoCallOutline, IoLocationOutline } from 'react-icons/io5';

function ExpertCallingCard({ expert }) {
  const handleCall = () => {
    const rawPhone = expert.mobile || expert.phone || expert.contact_number;
    if (!rawPhone) return;
    window.location.href = `tel:${rawPhone.toString().replace(/\D/g, '')}`;
  };

  const name = expert.name || expert.customer_name || 'Unknown';
  const subject = expert.subject || expert.location || 'Enquiry';

  return (
    <div className="activity-item" style={{ padding: '8px 12px', background: '#F9FAFB' }}>
      <div className="activity-avatar" style={{ background: 'rgba(14, 103, 177, 0.1)', color: '#0E67B1' }}>
        {name[0].toUpperCase()}
      </div>
      <div className="activity-content">
        <div className="activity-title" style={{ fontSize: '13px' }}>
          {name}
        </div>
        <div className="activity-subtitle" style={{ fontSize: '11px' }}>
          <IoLocationOutline size={11} style={{ marginRight: 2 }} />
          {subject}
        </div>
      </div>
      {(expert.mobile || expert.phone || expert.contact_number) && (
        <button className="btn-secondary" style={{ padding: '6px', minWidth: '32px' }} onClick={handleCall}>
          <IoCallOutline size={14} />
        </button>
      )}
    </div>
  );
}

export default ExpertCallingCard
